import { field_color_theme } from 'framework/field/constants';
import { IconTheme } from 'framework/Icon/types';

export const icon_dark_theme: IconTheme = {
  normal: 'inherit',
  hover: 'inherit',
  focus: 'inherit',
  disabled: field_color_theme.disabled,
};
